export const VolumeUp = ({ color = "white" }: { color?: string }) => {
  return (
    <svg
      color={color}
      style={{ width: "100%", height: "100%" }}
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.00185 12.0001C3.99906 13.2298 3.94419 14.907 4.70494 15.5339C5.41453 16.1187 5.91395 15.968 7.20945 16.0631C8.50587 16.1591 11.242 19.97 13.3512 18.7646C14.4393 17.9089 14.5202 16.1151 14.5202 12.0001C14.5202 7.88515 14.4393 6.09135 13.3512 5.23571C11.242 4.02938 8.50587 7.84121 7.20945 7.93717C5.91395 8.03225 5.41453 7.88157 4.70494 8.46635C3.94419 9.09328 3.99906 10.7705 4.00185 12.0001Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.0843 5.90399C22.6344 9.57501 22.6427 14.4174 20.0843 18.0956"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.5813 8.31442C18.8926 10.6051 18.8926 13.4025 17.5813 15.6861"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Send = ({ color = "white" }: { color: string }) => {
  return (
    <svg
      color={color}
      width="18"
      height="19"
      viewBox="0 0 18 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.8744 6.36926L7.58178 10.7077L2.69958 7.65404C2.00006 7.21639 2.14557 6.15386 2.93679 5.92248L14.5284 2.52786C15.2529 2.3155 15.9244 2.9929 15.7092 3.71978L12.2798 15.3033C12.0449 16.0957 10.9884 16.2372 10.5549 15.5347L7.5795 10.7084"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const Mute = ({ color = "white" }: { color?: string }) => {
  return (
    <svg
      color={color}
      style={{ width: "100%", height: "100%" }}
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Iconly/Light/Volume Off">
        <g id="Volume Off">
          <path
            id="Stroke 1"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.5329 9.46704L7.71357 16.2869C7.53632 16.1842 7.36841 16.1189 7.21915 16.1096C5.92245 16.0163 5.4187 16.1656 4.70971 15.5592C3.94476 14.9061 4.00073 13.1615 4.00073 11.8834C4.00073 10.6052 3.94476 8.86063 4.70971 8.20757C5.4187 7.60115 5.92245 7.75975 7.21915 7.65713C8.51584 7.55451 11.2585 3.59882 13.3761 4.84897C14.2344 5.54868 14.4676 6.8548 14.5329 9.46704Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Stroke 3"
            d="M14.5329 13.9172C14.4955 16.7907 14.2717 18.1901 13.3761 18.9178C12.3966 19.4962 11.2865 18.9644 10.2416 18.2088"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Stroke 5"
            d="M4.00122 20L7.71406 16.2869L14.5334 9.46706L20 4"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
    </svg>
  );
};
export const CheckIcon = () => {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.993 10.5697L11.375 15.1877C11.228 15.3347 11.037 15.4077 10.845 15.4077C10.652 15.4077 10.461 15.3347 10.314 15.1877L8.005 12.8787C7.712 12.5857 7.712 12.1107 8.005 11.8177C8.298 11.5247 8.772 11.5247 9.065 11.8177L10.845 13.5967L14.932 9.50866C15.225 9.21566 15.7 9.21566 15.993 9.50866C16.286 9.80166 16.286 10.2767 15.993 10.5697ZM12 2.84766C6.762 2.84766 2.5 7.10966 2.5 12.3477C2.5 17.5867 6.762 21.8477 12 21.8477C17.238 21.8477 21.5 17.5867 21.5 12.3477C21.5 7.10966 17.238 2.84766 12 2.84766Z"
        fill="currentColor"
      />
    </svg>
  );
};
export const AfterEffectskIcon = () => {
  return (
    <svg
      width="31"
      height="32"
      viewBox="0 0 31 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        y="0.806641"
        width="30.375"
        height="30.3876"
        rx="6"
        fill="#E8E8FF"
      />
      <path
        d="M20.2378 21.2267C19.2 21.2267 18.2508 20.8342 17.5547 20.0872C16.9345 19.4161 16.5169 18.4792 16.4409 17.5549C16.4409 17.5169 16.4409 17.4662 16.4409 17.4283C16.3903 16.5293 16.6434 15.681 17.1244 15.0099C17.7445 14.1489 18.7444 13.6298 19.7822 13.6045C20.6302 13.6172 21.4655 13.9084 22.0983 14.4908C22.7184 15.0606 23.1108 15.8329 23.2247 16.6686C23.2373 16.8078 23.25 17.1624 23.25 17.1624C23.25 17.8461 22.7184 18.3779 22.0603 18.3779H18.6305C18.7191 18.5298 18.8203 18.6818 18.9342 18.7957C19.7316 19.644 20.8959 19.2768 21.3516 19.0743C21.8325 18.859 22.3894 19.0743 22.6045 19.5681C22.8197 20.0492 22.6045 20.6063 22.1109 20.8215C21.4781 21.1001 20.8327 21.2394 20.2125 21.2394L20.2378 21.2267ZM18.4659 16.4787H21.225C21.1364 16.2507 20.9972 16.0482 20.82 15.8962C20.5416 15.643 20.1745 15.5037 19.8202 15.5164C19.3772 15.5164 18.9216 15.7696 18.6558 16.1368C18.5798 16.2381 18.5166 16.3647 18.4659 16.4913V16.4787Z"
        fill="#000051"
      />
      <path
        d="M15.0352 21.2C14.6681 21.2 14.3138 20.9848 14.1619 20.6176L11.5547 14.2742L8.94751 20.6176C8.74501 21.0987 8.20078 21.3393 7.70719 21.1367C7.22625 20.9341 6.98577 20.377 7.18827 19.8959L10.6687 11.4253C10.9598 10.7163 12.1369 10.7163 12.428 11.4253L15.9084 19.8959C16.1109 20.377 15.8831 20.9341 15.3895 21.1367C15.2756 21.1873 15.1491 21.2127 15.0225 21.2127L15.0352 21.2Z"
        fill="#000051"
      />
      <path
        d="M13.7831 18.1746H9.30273C8.78383 18.1746 8.35352 17.7441 8.35352 17.225C8.35352 16.7059 8.78383 16.2754 9.30273 16.2754H13.7831C14.302 16.2754 14.7323 16.7059 14.7323 17.225C14.7323 17.7441 14.302 18.1746 13.7831 18.1746Z"
        fill="#000051"
      />
    </svg>
  );
};
export const AIIcon = () => {
  return (
    <svg
      width="30"
      height="31"
      viewBox="0 0 30 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect y="0.152344" width="30" height="30" rx="6" fill="#F5EDFF" />
      <path
        d="M13.8507 14.2253C14.4064 13.6007 15.3633 13.5449 15.9879 14.1006C16.6125 14.6563 16.6683 15.6132 16.1126 16.2378L9.39573 23.6447C8.84 24.2693 7.88315 24.3252 7.25855 23.7694C6.63394 23.2137 6.57811 22.2569 7.13384 21.6323L13.8507 14.2253Z"
        stroke="#9747FF"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.1398 11.964L19.0269 11.6584C18.6012 10.5061 17.694 9.59764 16.5434 9.17126L16.2383 9.05819L16.5434 8.94511C17.694 8.51873 18.6012 7.61023 19.0269 6.45796L19.1398 6.15234L19.2528 6.45796C19.6785 7.61023 20.5857 8.51873 21.7363 8.94511L22.0415 9.05819L21.7363 9.17126C20.5857 9.59764 19.6785 10.5061 19.2528 11.6584L19.1398 11.964Z"
        stroke="#9747FF"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.3281 11.4757C11.1126 10.7666 10.5585 10.2117 9.85059 9.99588C10.5585 9.78007 11.1126 9.22516 11.3281 8.51611C11.5436 9.22516 12.0977 9.78007 12.8056 9.99588C12.0977 10.2117 11.5436 10.7666 11.3281 11.4757Z"
        stroke="#9747FF"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.042 17.3923C21.866 16.8131 21.4134 16.3598 20.835 16.1835C21.4134 16.0072 21.866 15.5538 22.042 14.9746C22.2181 15.5538 22.6707 16.0072 23.249 16.1835C22.6707 16.3598 22.2181 16.8131 22.042 17.3923Z"
        stroke="#9747FF"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.5352 15.7524L14.7408 17.7147"
        stroke="#9747FF"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.7971 20.5049H18.7871"
        stroke="#9747FF"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const BookIcon = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="30" height="30" rx="6" fill="#FFEFF7" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.1477 6.75C9.13064 6.75 8.30664 7.574 8.30664 8.59103V18.7813C8.80859 18.4614 9.40454 18.2762 10.0436 18.2762H21.6873V7.1987C21.6873 6.9509 21.4866 6.75 21.2386 6.75H10.1477ZM21.6886 19.7762H10.0436C9.08472 19.7762 8.30664 20.5536 8.30664 21.5131C8.30664 22.4725 9.08472 23.25 10.0436 23.25H21.2454C21.4925 23.25 21.6927 23.0507 21.6941 22.8043L21.6886 19.7762ZM6.80664 21.5131V8.59103C6.80664 6.74557 8.30221 5.25 10.1477 5.25H21.2386C22.3158 5.25 23.1873 6.12326 23.1873 7.1987V19.0262L23.1941 22.8038V22.8074C23.1909 23.8817 22.3191 24.75 21.2454 24.75H10.0436C8.25668 24.75 6.80664 23.3013 6.80664 21.5131ZM10.9214 9.27906C11.263 8.91284 11.7367 8.72572 12.2508 8.72572H17.8843C18.3992 8.72572 18.8736 8.91238 19.2154 9.2796C19.5515 9.64072 19.7036 10.1156 19.7036 10.5995V12.3771C19.7036 12.8607 19.5514 13.3355 19.2155 13.6965C18.8739 14.0637 18.3997 14.2509 17.8843 14.2509H12.2508C11.7357 14.2509 11.2617 14.0635 10.9202 13.6967C10.5843 13.3359 10.4315 12.8612 10.4315 12.3771V10.5995C10.4315 10.1142 10.5853 9.6395 10.9214 9.27906ZM12.0184 10.3021C11.9841 10.3389 11.9315 10.4261 11.9315 10.5995V12.3771C11.9315 12.5508 11.984 12.638 12.0182 12.6747C12.0466 12.7053 12.1073 12.7509 12.2508 12.7509H17.8843C18.0287 12.7509 18.0891 12.7051 18.1172 12.6748C18.1511 12.6384 18.2036 12.5512 18.2036 12.3771V10.5995C18.2036 10.4247 18.151 10.3377 18.1174 10.3016C18.0895 10.2716 18.0291 10.2257 17.8843 10.2257H12.2508C12.1082 10.2257 12.0473 10.2711 12.0184 10.3021Z"
        fill="#FF0088"
      />
    </svg>
  );
};
export const CopyIcon = () => {
  return (
    <svg
      width="31"
      height="31"
      viewBox="0 0 31 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="30" height="30" rx="6" fill="#FFF2EC" />
      <path
        d="M16.25 8H11C10.6022 8 10.2206 8.15804 9.93934 8.43934C9.65804 8.72064 9.5 9.10218 9.5 9.5V21.5C9.5 21.8978 9.65804 22.2794 9.93934 22.5607C10.2206 22.842 10.6022 23 11 23H20C20.3978 23 20.7794 22.842 21.0607 22.5607C21.342 22.2794 21.5 21.8978 21.5 21.5V13.25L16.25 8Z"
        stroke="#FFA87F"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.25 8V13.25H21.5"
        stroke="#FFA87F"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const CurrentStepIcon = () => {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="1"
        y="0.587891"
        width="19"
        height="19"
        rx="9.5"
        stroke="#1B2B4B"
      />
      <rect x="5.5" y="5.08789" width="10" height="10" rx="5" fill="#1B2B4B" />
    </svg>
  );
};
export const NextStepCircleIcon = () => {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="1"
        y="0.587891"
        width="19"
        height="19"
        rx="9.5"
        stroke="#CDD5E5"
      />
    </svg>
  );
};
export const CircleCheckedIcon = () => {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="1"
        y="0.587891"
        width="19"
        height="19"
        rx="9.5"
        stroke="#1B2B4B"
      />
      <path
        d="M9.16681 12.4789L6.97147 10.2835L6.02881 11.2262L9.16681 14.3642L15.6381 7.89286L14.6955 6.9502L9.16681 12.4789Z"
        fill="#1B2B4B"
      />
    </svg>
  );
};
export const LeftArrow = () => {
  return (
    <svg
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.75 9.5L4.25 9.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.5 14.75L4.25 9.5L9.5 4.25"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const RightArrow = () => {
  return (
    <svg
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.25 9.5L14.75 9.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.5 4.25L14.75 9.5L9.5 14.75"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const CloseXIcon = () => {
  return (
    <svg
      width="18"
      height="19"
      viewBox="0 0 18 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.6033 4.89648L4.80957 13.6902"
        stroke="#515458"
        strokeWidth="1.95417"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.80957 4.89648L13.6033 13.6902"
        stroke="#515458"
        strokeWidth="1.95417"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const LeftOutlinedIcon = () => {
  return (
    <svg
      width="6"
      height="12"
      viewBox="0 0 6 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.25 1.5L0.75 6L5.25 10.5"
        stroke="#45464E"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const OutlinedImageIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.2273 1.0625H4.73825C2.47925 1.0625 1.0625 2.663 1.0625 4.928V11.0375C1.0625 13.3025 2.47325 14.903 4.73825 14.903H11.2235C13.4923 14.903 14.9022 13.3025 14.9022 11.0375V4.928C14.9052 2.663 13.4945 1.0625 11.2273 1.0625Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.02779 5.5886C7.02779 6.3536 6.40829 6.9731 5.64329 6.9731C4.87904 6.9731 4.25879 6.3536 4.25879 5.5886C4.25879 4.8236 4.87904 4.2041 5.64329 4.2041C6.40754 4.20485 7.02704 4.82435 7.02779 5.5886Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.9053 10.2133C14.213 9.50077 12.8818 8.06152 11.4343 8.06152C9.986 8.06152 9.15125 11.2363 7.7585 11.2363C6.36575 11.2363 5.1005 9.80077 3.9845 10.721C2.8685 11.6405 1.8125 13.5208 1.8125 13.5208"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const OutlinedColorIcon = () => {
  return (
    <svg
      width="14"
      height="17"
      viewBox="0 0 14 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.00016 1.01758L11.2452 5.26258C12.0847 6.10154 12.6565 7.17063 12.8883 8.33462C13.1202 9.49861 13.0016 10.7052 12.5476 11.8018C12.0936 12.8984 11.3245 13.8357 10.3377 14.4952C9.35096 15.1546 8.19076 15.5066 7.00391 15.5066C5.81705 15.5066 4.65686 15.1546 3.67008 14.4952C2.6833 13.8357 1.91427 12.8984 1.46026 11.8018C1.00625 10.7052 0.887655 9.49861 1.11949 8.33462C1.35132 7.17063 1.92315 6.10154 2.76266 5.26258L7.00016 1.01758Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const OutlinedTextIcon = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.75 15H11.25"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 5.25V3H15V5.25"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 3V15"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const PlayCircleFilledIcon = () => {
  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="2" y="2" width="32" height="32" rx="16" fill="#2E2E2E" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.5 17.9927C22.5 16.776 16.2638 12.8837 15.5564 13.5835C14.8489 14.2834 14.7809 21.6361 15.5564 22.4019C16.3318 23.1704 22.5 19.2094 22.5 17.9927Z"
        fill="white"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const PauseCircleFilledIcon = () => {
  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="2" y="2" width="32" height="32" rx="16" fill="#2E2E2E" />
      <rect x="14" y="12" width="3.5" height="12" rx="1.75" fill="white" />
      <rect x="18.5" y="12" width="3.5" height="12" rx="1.75" fill="white" />
    </svg>
  );
};

export const AudioIcon = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.5 15.75C5.74264 15.75 6.75 14.7426 6.75 13.5C6.75 12.2574 5.74264 11.25 4.5 11.25C3.25736 11.25 2.25 12.2574 2.25 13.5C2.25 14.7426 3.25736 15.75 4.5 15.75Z"
        stroke="#4D5566"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.75 13.5V3.75L15.75 2.25V12"
        stroke="#4D5566"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.5 14.25C14.7426 14.25 15.75 13.2426 15.75 12C15.75 10.7574 14.7426 9.75 13.5 9.75C12.2574 9.75 11.25 10.7574 11.25 12C11.25 13.2426 12.2574 14.25 13.5 14.25Z"
        stroke="#4D5566"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const DeleteIcon = () => {
  return (
    <svg
      width="15"
      height="16"
      viewBox="0 0 15 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.4933 6.10156C12.4933 6.10156 12.0861 11.1528 11.8498 13.2806C11.7373 14.2968 11.1096 14.8923 10.0813 14.9111C8.1246 14.9463 6.1656 14.9486 4.2096 14.9073C3.22035 14.8871 2.6031 14.2841 2.49285 13.2858C2.2551 11.1393 1.8501 6.10156 1.8501 6.10156"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.531 3.68066H0.8125"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.0804 3.68023C10.4917 3.68023 9.98468 3.26398 9.86918 2.68723L9.68693 1.77523C9.57443 1.35448 9.19343 1.06348 8.75918 1.06348H5.58443C5.15018 1.06348 4.76918 1.35448 4.65668 1.77523L4.47443 2.68723C4.35893 3.26398 3.85193 3.68023 3.26318 3.68023"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const UploadIcon = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.75 11.25V14.25C15.75 14.6478 15.592 15.0294 15.3107 15.3107C15.0294 15.592 14.6478 15.75 14.25 15.75H3.75C3.35218 15.75 2.97064 15.592 2.68934 15.3107C2.40804 15.0294 2.25 14.6478 2.25 14.25V11.25"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.75 6L9 2.25L5.25 6"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 2.25V11.25"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const InfoIcon = () => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_7766_12576)">
        <path
          d="M6 11C8.76142 11 11 8.76142 11 6C11 3.23858 8.76142 1 6 1C3.23858 1 1 3.23858 1 6C1 8.76142 3.23858 11 6 11Z"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6 8.5H6.005"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.54492 4.50028C4.66247 4.16612 4.8945 3.88434 5.1999 3.70485C5.5053 3.52536 5.86437 3.45975 6.21351 3.51964C6.56265 3.57953 6.87933 3.76105 7.10746 4.03205C7.33559 4.30305 7.46045 4.64605 7.45992 5.00028C7.45992 6.00028 5.95992 6.50028 5.95992 6.50028"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_7766_12576">
          <rect width="12" height="12" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const MusicNoteIcon = () => {
  return (
    <svg
      width="18"
      height="19"
      viewBox="0 0 18 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.5 16.25C5.74264 16.25 6.75 15.2426 6.75 14C6.75 12.7574 5.74264 11.75 4.5 11.75C3.25736 11.75 2.25 12.7574 2.25 14C2.25 15.2426 3.25736 16.25 4.5 16.25Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.75 14V4.25L15.75 2.75V12.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.5 14.75C14.7426 14.75 15.75 13.7426 15.75 12.5C15.75 11.2574 14.7426 10.25 13.5 10.25C12.2574 10.25 11.25 11.2574 11.25 12.5C11.25 13.7426 12.2574 14.75 13.5 14.75Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const VideoIcon = () => {
  return (
    <svg
      width="18"
      height="19"
      viewBox="0 0 18 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.2227 12.1537C12.2834 13.5278 11.1744 14.6897 9.74602 14.7481C9.64081 14.7525 4.51154 14.7422 4.51154 14.7422C3.09003 14.8501 1.84592 13.8286 1.7338 12.4597C1.72535 12.3577 1.72766 6.85414 1.72766 6.85414C1.66468 5.47862 2.77209 4.31374 4.20128 4.25313C4.30803 4.24796 9.43039 4.25757 9.43039 4.25757C10.8588 4.15113 12.1068 5.18001 12.2173 6.55553C12.225 6.65458 12.2227 12.1537 12.2227 12.1537Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.2251 7.98488L14.6948 5.96363C15.3068 5.46263 16.2248 5.89913 16.2241 6.68888L16.2151 12.2006C16.2143 12.9904 15.2956 13.4231 14.6851 12.9221L12.2251 10.9009"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const NumberIcon = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 11.25H15"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 6.75H15"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 2.25L10.5 15.75"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.5 2.25L6 15.75"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const PowerIcon = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.7698 4.98047C14.7136 5.92456 15.3563 7.1273 15.6166 8.43661C15.8768 9.74592 15.743 11.103 15.2321 12.3363C14.7211 13.5696 13.856 14.6236 12.746 15.3652C11.636 16.1068 10.331 16.5027 8.9961 16.5027C7.66117 16.5027 6.35621 16.1068 5.24623 15.3652C4.13624 14.6236 3.27108 13.5696 2.76012 12.3363C2.24916 11.103 2.11536 9.74592 2.37563 8.43661C2.63591 7.1273 3.27856 5.92456 4.22235 4.98047"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 1.5V9"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const LinkIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_7683_12797)">
        <path
          d="M6.6665 8.66697C6.95281 9.04972 7.31808 9.36642 7.73754 9.5956C8.157 9.82477 8.62084 9.96105 9.0976 9.99519C9.57437 10.0293 10.0529 9.96055 10.5007 9.79349C10.9486 9.62643 11.3552 9.36502 11.6932 9.02697L13.6932 7.02697C14.3004 6.3983 14.6363 5.55629 14.6288 4.6823C14.6212 3.80831 14.2706 2.97227 13.6526 2.35424C13.0345 1.73621 12.1985 1.38565 11.3245 1.37806C10.4505 1.37046 9.60851 1.70644 8.97984 2.31364L7.83317 3.45364"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.33347 7.33381C9.04716 6.95106 8.68189 6.63435 8.26243 6.40518C7.84297 6.17601 7.37913 6.03973 6.90237 6.00559C6.4256 5.97144 5.94707 6.04023 5.49924 6.20729C5.0514 6.37434 4.64472 6.63576 4.3068 6.97381L2.3068 8.97381C1.69961 9.60248 1.36363 10.4445 1.37122 11.3185C1.37881 12.1925 1.72938 13.0285 2.3474 13.6465C2.96543 14.2646 3.80147 14.6151 4.67546 14.6227C5.54945 14.6303 6.39146 14.2943 7.02013 13.6871L8.16013 12.5471"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_7683_12797">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const EyeIcon = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.3712 9.04045C11.3712 10.3499 10.3092 11.4112 8.99966 11.4112C7.69016 11.4112 6.62891 10.3499 6.62891 9.04045C6.62891 7.7302 7.69016 6.66895 8.99966 6.66895C10.3092 6.66895 11.3712 7.7302 11.3712 9.04045Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.9985 14.5165C11.8545 14.5165 14.4668 12.463 15.9375 9.03998C14.4668 5.61698 11.8545 3.56348 8.9985 3.56348H9.0015C6.1455 3.56348 3.53325 5.61698 2.0625 9.03998C3.53325 12.463 6.1455 14.5165 9.0015 14.5165H8.9985Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
